import Vue from "vue";
import {AddPracticeRequest, AddSeafaringPracticeRequest, PracticesClient} from "@/api-client";
import {Prop} from "vue-property-decorator";
import {Location} from "vue-router";

export abstract class PracticeAddBase<T extends AddPracticeRequest> extends Vue {
    @Prop({ required: true })
    seafarerId!: string;

    @Prop({default: null})
    returnRoute!: Location | null;

    async submit(model: T): Promise<void> {
        return await new PracticesClient()
            .add(model, this.seafarerId)
            .then(async result => {
                const route = (this.returnRoute ? this.returnRoute : {name: this.getDefaultReturnRouteName(model), params: { id: result.id } }) as Location;

                const params = route.params || {};
                params.addedItemId = result.id;
                route.params = params;

                await this.$router.replace(route);
            });
    }
    
    abstract getDefaultReturnRouteName(model: T): string;
}